(function () {
  'use strict';

  function debounce(fn, delay) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, delay);
    };
  }

  var invalidLibelles = ['-', '--', '.', '0'];

  function initArtisteSearch(input) {
    if (input.dataset.artisteSearchInit) return;
    input.dataset.artisteSearchInit = '1';

    // Find the JS-enabled UL (not the no-JS fallback list)
    var fieldset = input.closest('fieldset');
    var list = fieldset && (
      fieldset.querySelector('ul.no-js-hidden') ||
      fieldset.querySelector('ul[role="list"]:not(.no-js-list):not(.no-js)')
    );
    if (!list) return;

    var apiItems = [];

    // Pre-loaded actor cache (loaded once per facet instance on first focus)
    var cachedActors = null;
    var cacheLoading = false;
    var cacheCallbacks = [];

    // Query original (non-API) items fresh each time to handle dynamic DOM
    // Exclude items whose label text is a raw GID (gid://shopify/...)
    function getOriginalItems() {
      return Array.prototype.slice.call(list.querySelectorAll('li:not(.facet-artiste-api)')).filter(function (li) {
        return getItemText(li).indexOf('gid://') === -1;
      });
    }

    function hideGidItems() {
      Array.prototype.slice.call(list.querySelectorAll('li:not(.facet-artiste-api)')).forEach(function (li) {
        if (getItemText(li).indexOf('gid://') !== -1) li.style.display = 'none';
      });
    }
    var listObserver = new MutationObserver(hideGidItems);
    listObserver.observe(list, { childList: true });
    hideGidItems();

    function getItemText(li) {
      var label = li.querySelector('label');
      if (!label) return '';
      var clone = label.cloneNode(true);
      var svgs = clone.querySelectorAll('svg');
      for (var i = 0; i < svgs.length; i++) svgs[i].remove();
      return clone.textContent.trim().toLowerCase();
    }

    function getItemKey(li) {
      var label = li.querySelector('label');
      return label ? (label.getAttribute('keyFiltreValue') || '') : '';
    }

    function removeApiItems() {
      apiItems.forEach(function (li) {
        if (li.parentNode) li.parentNode.removeChild(li);
      });
      apiItems = [];
    }

    function filterDomItems(q) {
      getOriginalItems().forEach(function (li) {
        if (q) {
          var match = getItemText(li).indexOf(q) !== -1;
          if (match) {
            if (li.classList.contains('hidden')) {
              li.dataset.wasHidden = '1';
              li.classList.remove('hidden');
            }
            li.style.display = '';
          } else {
            li.style.display = 'none';
          }
        } else {
          if (li.dataset.wasHidden) {
            li.classList.add('hidden');
            delete li.dataset.wasHidden;
          }
          li.style.display = '';
        }
      });
    }

    function addApiItem(artiste) {
      var li = document.createElement('li');
      li.className = 'list-menu__item facets__item facet-artiste-api';

      var label = document.createElement('label');
      label.className = 'facet-checkbox';
      label.setAttribute('keyFiltre', filterKey);
      label.setAttribute('keyFiltreValue', artiste.key);

      var checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.name = filterKey;
      checkbox.value = artiste.key;

      var svgBox = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svgBox.setAttribute('width', '1.6rem'); svgBox.setAttribute('height', '1.6rem');
      svgBox.setAttribute('viewBox', '0 0 16 16'); svgBox.setAttribute('aria-hidden', 'true');
      svgBox.setAttribute('focusable', 'false'); svgBox.style.overflow = 'visible';
      var r1 = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
      r1.setAttribute('width', '16'); r1.setAttribute('height', '16');
      r1.setAttribute('stroke', 'currentColor'); r1.setAttribute('fill', 'none'); r1.setAttribute('stroke-width', '1');
      var r2 = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
      r2.setAttribute('width', '16'); r2.setAttribute('height', '16');
      r2.setAttribute('stroke', 'none'); r2.setAttribute('fill', '#FCF9F9');
      svgBox.appendChild(r1); svgBox.appendChild(r2);

      var svgCheck = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svgCheck.setAttribute('aria-hidden', 'true'); svgCheck.setAttribute('class', 'icon icon-checkmark');
      svgCheck.setAttribute('width', '1.1rem'); svgCheck.setAttribute('height', '0.7rem');
      svgCheck.setAttribute('viewBox', '0 0 11 7'); svgCheck.setAttribute('fill', 'none');
      var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', 'M1.5 3.5L3.5 5.5L9.5 1.5'); path.setAttribute('stroke', 'currentColor');
      path.setAttribute('stroke-width', '2'); path.setAttribute('stroke-linecap', 'round');
      svgCheck.appendChild(path);

      var text = document.createTextNode('\n' + artiste.libelle + (artiste.qte ? ' (' + artiste.qte + ')' : '') + '\n');

      label.appendChild(checkbox);
      label.appendChild(svgBox);
      label.appendChild(svgCheck);
      label.appendChild(text);
      li.appendChild(label);
      list.appendChild(li);
      apiItems.push(li);

      checkbox.addEventListener('change', function () {
        this.dispatchEvent(new Event('input', { bubbles: true }));
      });
    }

    function flushCache(actors) {
      cachedActors = actors;
      var cbs = cacheCallbacks.splice(0);
      cbs.forEach(function (cb) { cb(cachedActors); });
    }

    // Priorité 1 : JSON statique pré-généré (couvre tous les acteurs/réalisateurs).
    // Priorité 2 : agrégation BH (top-N seulement, fallback).
    var filterKey = input.dataset.filterKey || 'fk_protagonistes';
    var isRealisateur = (filterKey === 'fk_realisateur');

    function loadCache(callback) {
      if (cachedActors !== null) { callback(cachedActors); return; }
      cacheCallbacks.push(callback);
      if (cacheLoading) return;
      cacheLoading = true;

      var jsonUrl = isRealisateur ? window._realisateurJsonUrl : window._acteurJsonUrl;
      if (jsonUrl) {
        fetch(jsonUrl)
          .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
          .then(function (data) {
            var actors = Array.isArray(data) ? data.filter(function (a) {
              return a && a.libelle && invalidLibelles.indexOf(a.libelle) === -1;
            }) : [];
            // Un JSON vide est un fichier casse (generation en echec, asset ecrase),
            // pas une collection sans artiste : on bascule sur l'agregation BH
            // plutot que de laisser la recherche muette.
            if (!actors.length) { loadCacheFromBH(); return; }
            flushCache(actors);
          })
          .catch(function () { loadCacheFromBH(); });
        return;
      }
      loadCacheFromBH();
    }

    function loadCacheFromBH() {
      // bhmoteur n'existe pas sur toutes les pages a facettes : sans le typeof,
      // la variable non declaree leve une ReferenceError avalee par le .catch,
      // et la recherche reste muette sans trace.
      var params = null;
      try { params = (typeof bhmoteur !== 'undefined' && bhmoteur) ? bhmoteur.getParams() : null; }
      catch (e) { params = null; }
      if (!params) console.warn('[facets-artiste] cache JSON vide et moteur BH indisponible : recherche limitee aux valeurs deja affichees');
      if (!params || !params.url) { flushCache([]); return; }

      $.ajax({
        url: params.url,
        type: 'POST',
        data: {
          q: '',
          limit: 1,
          from: 0,
          return_aggregations: true,
          is_collection: true,
          collection: params.filter_m_id_collection,
          debug: false
        },
        success: function (d) {
          var actors = [];
          var agg = d.result && d.result.aggregations;
          if (agg) {
            for (var i = 0; i < agg.length; i++) {
              if (agg[i].key === filterKey || agg[i].key === 'fk_protagonistes') {
                actors = (agg[i].data || []).filter(function (a) {
                  return invalidLibelles.indexOf(a.libelle) === -1;
                });
                break;
              }
            }
          }
          flushCache(actors);
        },
        error: function () { flushCache([]); }
      });
    }

    var doSearch = debounce(function (q) {
      loadCache(function (actors) {
        removeApiItems();
        var domKeys = {};
        getOriginalItems().forEach(function (li) {
          var k = getItemKey(li);
          if (k) domKeys[k] = true;
        });
        actors.forEach(function (a) {
          if (a.libelle.toLowerCase().indexOf(q) !== -1 && !domKeys[a.key]) {
            addApiItem(a);
          }
        });
      });
    }, 300);

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); }
      if (e.key === 'Escape') { input.value = ''; filterDomItems(''); removeApiItems(); }
    });

    input.addEventListener('focus', function () {
      loadCache(function () {});
    });

    input.addEventListener('input', function (e) {
      e.stopPropagation();
      e.stopImmediatePropagation();
      var q = this.value.trim().toLowerCase();
      removeApiItems();
      if (!q || q.length < 2) { filterDomItems(''); return; }
      filterDomItems(q);
      doSearch(q);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-facet-artiste-search]').forEach(initArtisteSearch);
  }

  var observer = new MutationObserver(initAll);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', initAll);
  }
})();
